export class VendaEntrega {
  id: number;
  idCupom: string;
  rua: string;
  numero: string;
  complemento: string;
  bairro: string;
  cidade: string;
  uf: string;
  cep: string;
  ibge: number;
  nomeResponsavel?: string;
  telefoneResponsavel?: string;
  tipo: number;
  cpfCnpj: string;
  rgIe: string;
  nome: string;
  celular: string;
  email: string;
  antigo: boolean;
  peso: number;
  cubagem: string;
  volume: number;
  observacao: string;
  idTransportadora: number;
  tipoEndereco: number;
}
